import course1 from './assets/course-1.webp'
import course2 from './assets/course-2.webp'
import course3 from './assets/course-3.webp'
import course4 from './assets/course-4.webp'

// Presentation mapping for live course data (@astro/api → CourseCard props).
// Verified live against admin.astrorajumaharaj.com/api/v1/courses — the
// backend already returns camelCase fields very close to CourseCard's props
// (title/coverImage/category/level/price/courseType/…), so this is mostly a
// light touch-up rather than a full reshape.

const DIFFICULTY_LABEL = {
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
}

/** shortDescription is an HTML blurb — flatten it for the two-line clamp. */
const stripHtml = (html) =>
  String(html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

const formatPrice = (price) => {
  const value = Number(price)
  if (!Number.isFinite(value) || value <= 0) return 'Free'
  return `₹${value.toLocaleString('en-IN')}`
}

/** Cover art fallback, cycled by list position — not every course has a
 * `coverImage` uploaded (several live records return null). */
export const FALLBACK_IMAGES = [course1, course2, course3, course4]

/** Instructor names, tolerating both the live `instructors` array and the
 * removed singular `instructor` shape (mirrors @astro/api's courseInstructors
 * — not imported to keep this package presentation-only). */
const instructorNames = (record) => {
  const list = Array.isArray(record.instructors)
    ? record.instructors
    : record.instructor
      ? [record.instructor]
      : []
  return list.map((i) => i?.name).filter(Boolean)
}

/** Shapes a live /courses record into the props CourseCard renders. */
export function decorateCourse(record, index = 0) {
  const difficulty = String(record.level ?? '').toLowerCase()
  const effectivePrice = record.discountPrice ?? record.price

  return {
    id: record.id,
    slug: record.slug,
    title: record.title,
    desc: stripHtml(record.shortDescription),
    image: record.coverImage || FALLBACK_IMAGES[index % FALLBACK_IMAGES.length],
    tier: `${DIFFICULTY_LABEL[difficulty] ?? 'All Levels'} Tier`,
    tierTag: DIFFICULTY_LABEL[difficulty] ?? 'All Levels',
    duration: record.totalDuration ? `${record.totalDuration} Hours` : 'Self-paced',
    isLive: record.courseType === 'live',
    ctaLabel: formatPrice(effectivePrice) === 'Free' ? 'START FREE' : 'VIEW COURSE',
    category: record.category || 'General',
    price: formatPrice(effectivePrice),
    certified: Boolean(record.certificateAvailable),
    instructors: instructorNames(record),
  }
}

export const LEVEL_TABS = [
  { id: 'all', label: 'All Levels' },
  { id: 'beginner', label: 'Beginner' },
  { id: 'intermediate', label: 'Intermediate' },
  { id: 'advanced', label: 'Advanced' },
]
